export default "__VITE_ASSET__DzM7UlZI__"